// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { VALID_REPORT_NAME_REGEX } from 'logic/data/Izenda.ReportDesignerConstants';

export default {
  REPORT_PART_MAX_WIDTH: 12,
  REPORT_PART_MAX_HEIGHT: 4,
  TITLES_COLS_SHOW_PREVIEW: 11,
  TITLES_COLS_NOT_SHOW_PREVIEW: 12,
  EVENT_ENTER_CHANGE_NUMBERS_OF_RECORDS: 13,
  get COLLAPSE_DEFAULT() {
    return localizer.getText('REPORT_BODY_CONSTANTS_COLLAPSE_DEFAULT');
  },
  get EXPAND_RIGHT() {
    return localizer.getText('REPORT_BODY_CONSTANTS_EXPAND_RIGHT');
  },
  get EXPAND_LEFT() {
    return localizer.getText('REPORT_BODY_CONSTANTS_EXPAND_LEFT');
  },
  MESSAGES: {
    get M01() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_DELETE');
    },
    get M02() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_NAME_EXISTS');
    },
    get M03() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_NUMBER_OF_FIELDS_LIMITATION');
    },
    get M05() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_HAS_DATA_TYPE_IMAGE_OR_LOB');
    },
    get M06() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_CHANGE_TO_AGGREGATED_FIELD_CONFIRM');
    },
    get M11() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_RESOURCE_CANNOT_FOUND');
    },
    get M12() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_FIELD_NOT_EXIST');
    },
    get M13() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_COLUMN_NOT_EXIST');
    },
    get L02() {
      return localizer.getText('REPORTDESIGNER_MESSAGE_NO_RESULT_FOUND');
    },

    get M05_1() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_REMOVE_BINARY_FIELD');
    },
    get M08() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_CANNOT_GROUPED_OR_SORTED');
    },
    get M09() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_INVALID_COUNT_OPERATOR');
    },
    get M28() {
      return localizer.getText('REPORT_CANNOT_ADD_RUNNING_FIELD');
    },
    get M29() {
      return localizer.getText('REPORT_CONFIRM_DISABLE_MULTI_COLOR');
    },
    get M30() {
      return localizer.getText('REGRESSION_LINE_REMOVE_WARNING');
    },
    get MAP_DATA_UNAVAILABLE() {
      return localizer.getText('REPORT_BODY_CONSTANTS_MESSAGE_UNAVAILABLE_MAP_DATA');
    },
    get OUTDATED_REPORT() {
      return localizer.getText('COMMON_MESSAGES_OUTDATED_REPORT');
    }
  },
  get SWITCH_TO_PREVIEW() {
    return localizer.getText('REPORT_BODY_CONSTANTS_SWITCH_TO_PREVIEW');
  },
  get SWITCH_TO_CONFIGURATION() {
    return localizer.getText('REPORT_BODY_CONSTANTS_SWITCH_TO_CONFIGURATION');
  },
  NUMBER_OF_RECORD_LIMIT_CONSTRAINT: {
    numericality: {
      onlyInteger: true,
      lessThanOrEqualTo: Math.pow(2, 31),
      get notLessThanOrEqualTo() {
        return localizer.getText('REPORT_BODY_CONSTANTS_NUMBER_OF_RECORD_LIMIT_CONSTRAINT');
      }
    }
  },
  DRAG_ITEM: {
    REPORT_PART_FIELD_ITEM: 'ReportPartFieldItem'
  },
  FIELD_CONTAINER_HEIGHT: 70,
  FIELD_HIDDEN_LABEL: '●●●',
  FIELD_NAME_ALIAS_REGEX: '^{0} (\\((.*)\\) \\(\\d+\\)|\\((.*)\\))$',
  FIELD_NAME_WITH_FUNCTION_TEMPLATE: '{0} ({1})',
  NUMBER_BODY_COLS: 12,
  NUMBER_BODY_ROWS: 7,
  BODY_CELL_HEIGHT: 90,
  BODY_CELL_WIDTH: 90,
  REPORT_PART_SPACING: 0.5,
  REPORT_PART_LABEL: {
    get CHART() {
      return localizer.getText('COMMON_LABEL_CHART');
    },
    get FORM() {
      return localizer.getText('COMMON_LABEL_FORM');
    },
    get GAUGE() {
      return localizer.getText('COMMON_LABEL_GAUGE');
    },
    get GRID() {
      return localizer.getText('COMMON_LABEL_GRID');
    },
    get MAP() {
      return localizer.getText('COMMON_LABEL_MAP');
    }
  },
  REPORT_PART_MODE: {
    PREVIEW: 'preview',
    CONFIG: 'config'
  },
  TIMELAPSE: 500,
  REPORT_PART_SMALL_SIZE: 370,
  DIRECTION: {
    LEFT: 'left',
    RIGHT: 'right'
  },
  DIRECTION_STATE: {
    LEFT: 1,
    RIGHT: -1,
    NORMAL: 0
  },
  RUNNING_FUNCTION_INVALID_CONTAINER: {
    Grid: {
      Vertical: ['separators'],
      Horizontal: ['separators'],
      Drilldown: ['rows', 'separators'],
      Pivot: ['columns', 'rows', 'separators']
    },
    Chart: {
      Line: ['labels', 'separators'],
      Column: ['labels', 'separators'],
      Bar: ['labels', 'separators'],
      Area: ['labels', 'separators'],
      Pie: ['labels', 'separators'],
      Funnel: ['labels', 'separators'],
      Donut: ['labels', 'separators'],
      Combination: ['labels'],
      TreeMap: ['labels', 'separators'],
      HeatMap: ['labels', 'values'],
      Bubble: ['bubbleSize', 'valuesLabels'],
      Scatter: ['valuesLabels'],
      Waterfall: ['labels'],
      Sparkline: ['labels', 'separators']
    },
    Gauge: {
      LinearGauge: ['labels', 'separators'],
      SimpleGauge: ['labels', 'separators'],
      SolidGauge: ['labels', 'separators']
    },
    Map: {
      World: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude'],
      Continent: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude'],
      Country: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude']
    }
  },
  CONSTRAINTS: {
    NAME: {
      format: {
        pattern: VALID_REPORT_NAME_REGEX,
        get message() {
          return localizer.getText('INVALID_REPORT_NAME');
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportBodyConstants.js